<div class="onboarding-main-wrap p-3 p-md-5">
    <div class="row onboarding-step-count-wrap">
        <div class="col-1"></div>
        <div class="col-12 col-md-11 col-lg-6">
            <p class="font-semibold text-uppercase step-count-wrap mb-0">Step 2</p>
        </div>
    </div>
    <div class="row mb-4">
        <div class="col-1 d-none d-md-block">
            <div class="steps position-absolute">
                <div class="step">
                    <div class="step-number-wrapper">
                        <div class="step-number">1</div>
                    </div>
                </div>
                <div class="step">
                    <div class="step-number-wrapper step-two">
                        <div class="step-number">2</div>
                    </div>
                </div>
                <div class="step">
                    <div class="step-number-wrapper step-three">
                        <div class="step-number">3</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-md-11 col-lg-6">
            <h2 class="font-poppins card-header-wrap">Explore the Package Details for an Unmatched Experience!
            </h2>
        </div>
    </div>
    <div class="row onboarding-content-wrap">
        <div class="col-1 d-none d-md-block">
        </div>
        <div class="col-12 col-md-11 col-lg-6 order-2 order-sm-2 order-md-2 order-lg-1">
            <div class="w-100">
                <mat-card class="mat-elevation-z0 w-100 purple-card p-3 d-inline-block font-medium">
                    The charge is based on the number of properties registered in the key-automate
                </mat-card>
                <mat-card class="mat-elevation-z0 w-100 add-blue-card p-4 d-inline-block mt-4 package-card-wrap">
                    <div class="col-12">
                        <div class="d-flex justify-content-between">
                            <h4 class=" font-poppins font-16 font-semibold mb-2">${{packages?.minimumPackageAmount}}+GST
                                Minimum Monthly Charge</h4>
                            <div class="d-flex justify-content-center align-items-center price-card-check-wrap">
                                <mat-icon class=" material-icons-outlined mat-icon-18" mat-list-icon>done</mat-icon>
                            </div>
                        </div>

                        <p class="font-12 mb-0">This applies when the number of properties is less than 100. <br>
                            {{packages?.pricePerUnit}} per property per month +GST for additional property
                        </p>
                    </div>
                </mat-card>
            </div>
        </div>
        <div class="col-12 col-md-11 col-lg-5 order-1 order-sm-1 order-md-1 order-lg-2 mb-lg-0 mb-md-4 mb-sm-4 mb-4">
            <div class="d-flex justify-content-center align-items-center onboarding-img-wrap ps-4">
                <img src="../../../../assets/images/onboarding-step-2.svg" alt="">
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-1 d-none d-md-block"></div>
        <div class="col-6 col-md-11 col-lg-6">
            <div class="d-flex button-wrap">
                <button class="common-button light-gray mat-elevation-z0 me-3" mat-button mat-raised-button
                    (click)="back()">Back</button>
                <button class=" common-button blue mat-elevation-z0 me-3" mat-button mat-raised-button
                    (click)="next()">Next <mat-icon class="material-icons-outlined ms-2 mat-icon-14"
                        mat-list-icon>arrow_forward</mat-icon></button>
            </div>
        </div>
        <div class="col-5 col-md-5 col-lg-5 d-flex justify-content-end align-items-center">
            <a [href]="maintenanceAppUrl"
                class="blue mat-elevation-z0 me-3 d-flex justify-content-end align-items-center exit-onboard">
                <mat-icon class="material-icons-outlined me-1" mat-list-icon>exit_to_app</mat-icon> Exit Onboarding
            </a>
        </div>
    </div>
</div>